import { map, switchMap, tap } from "rxjs/operators";
import { Observable, of } from "rxjs";

import type { GrocResults, ProductData } from "../../../../def/landing";
import { post$ } from "../../../../serv/core/auth";
import { fetchAlternatives } from "../../../../serv/groc-product";
import { extractErrorMessage } from "$lib/util/format";

class Backups {
  constructor(
    readonly items: ProductData[] | null = null,
    readonly loading = false,
    readonly error = '',
  ) {}
}

export function fetchBackups(product: ProductData, search = ""): Observable<Backups> {
  return new Observable((o) => {
    const sub = of(product)
      .pipe(
        // tap(() => o.next(new Backups(null, true))),
        switchMap((p) => {
          if (p.disable_backup) return of(null);

          const store_code = p.store_code ?? p.store_id;

          if (search) {
            return post$<GrocResults>("ca://grocery/search/?display_combos=false", {
              store_code,
              text: search,
            }).pipe(
              map(
                (res) =>
                  res?.groceries.filter(
                    (b) => b.in_stock && b.catalogue_key !== p.alternative_item?.catalogue_key
                  ) ?? []
              )
            );
          }

          return fetchAlternatives({ ...p, store_code }).pipe(
            map((backups) =>
              backups
                .filter((b) => b.in_stock && b.catalogue_key !== p.alternative_item?.catalogue_key)
                .map((b) => ({
                  ...b,
                  price_now: b.price,
                  url: b.image_url.filename,
                  stock_status_message: b.stock_status_message ?? "",
                }))
            )
          );
        })
      )
      .subscribe({
        next: (items) => {
          o.next(new Backups(items, false));
        },
        error: (err) => {
          console.warn("Failed to load backups", err);
          o.next(new Backups(null, false, extractErrorMessage(err, 'Failed to load backups.')));
          o.complete();
        },
      });

    return () => sub.unsubscribe();
  });
}
